export enum OrderTrackingTypeEnum {
    'DELIVERY' = "Pick up & Delivery details",
    'Drop-off and Delivery details' = "Drop-off & Delivery details",
    'STORE' = "Drop-off & Collection details"
  };